import React, { Component } from "react";

import { getPhoneNumber, getEmail, getWorkingItemsFromChecks } from "../../../../util/common";

import { DealerInfoHeader, TotalAmount, ImageGallery, HeaderChecks, FixedItems, NotFixedItems, WorkingItems, TiresOverview, VatIndicator } from "../../components";

class StandardCheckTemplate extends Component {
  renderMainContent = () => {
    const { settings, communication } = this.props;

    const fixedItems = FixedItems.filterFixedItems(communication.appointment.interventions);
    const notFixedItems = NotFixedItems.filterNotFixedItems(communication.appointment.interventions);
    const workingItems = WorkingItems.filterWorkingsItems(getWorkingItemsFromChecks(communication.appointment.car_checks));
    const lettersMap = ImageGallery.getLettersMap(fixedItems, notFixedItems, workingItems);
    const correct_phone = communication.correct_phone || getPhoneNumber(communication);
    const correct_email = communication.correct_email || getEmail(communication);

    return (
      <div className="mainContent">
        <DealerInfoHeader settings={settings} />
        <HeaderChecks communication={communication} settings={settings} correctEmail={correct_email} correctPhone={correct_phone} showFooter />
        <FixedItems lettersMap={lettersMap} fixedItems={fixedItems} settings={settings} communication={communication} />
        {fixedItems.length > 0 && <TotalAmount communication={communication} settings={settings} />}
        <NotFixedItems lettersMap={lettersMap} notFixedItems={notFixedItems} settings={settings} communication={communication} />
        <ImageGallery lettersMap={lettersMap} />
        <TiresOverview communication={communication} settings={settings} />
        <WorkingItems lettersMap={lettersMap} workingItems={workingItems} communication={communication} />
        <VatIndicator include_vat={settings.include_vat} />
      </div>
    );
  };

  render() {
    return <div className="report-template-v2">{this.renderMainContent()}</div>;
  }
}

export default StandardCheckTemplate;
